import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useContext } from 'react'
import { Avatar } from '@material-ui/core'
import { AuthContext } from '../../context/AuthContext'

import dateFormat from 'dateformat'
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import SearchIcon from '@mui/icons-material/Search';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';



import { Dropdown } from 'react-bootstrap'
import ENDPOINT from '../../context/EndPoint'
import { MoreVert } from '@material-ui/icons'
const WebsiteLogs = ({ page}) => {

const {user} = useContext(AuthContext)
const userdata = user;





useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


    const [internships,setinternships] = useState("start");

    useEffect(()=>{
     
    
     
    getSupportLogs();
           
    }
    
    ,[])
    
    
    const  getSupportLogs = async ()=>{
      
        if (userdata!==null){

            fetch(`${ENDPOINT}admin-get-website-log.php?session=${user.SessionId} `)
            .then(r=>r.json())
            .then(result=>{
           
                    setinternships(result.data);
                   
                   
                
            })
        }
        else{
        
        }
          
            
            }    ;
    
    
    
    const [value, setValue] = React.useState(internships[0]);
    const [inputValue, setInputValue] = React.useState('');
  


    
const SearchChange = ()=>{
   // //  // console.log("search changed"+value)
}



const [category,setcategory] = useState("all")
const [query,setquery] = useState(null)

    return (
        <>


      
<div className=" flex-wrap  ">
<div className="container-fluid ">


<div className="flex align-items-center space-between mb-4">


<div className="flex col-lg-9">
<FormControl >
        <InputLabel id="demo-simple-select-label">Category</InputLabel>
      
<Select
  
  value={category}
  label="Category"
  onChange={(e)=>setcategory(e.target.value)}
>
  <MenuItem value={"all"}>All </MenuItem>
  <MenuItem value={"active"}>Active</MenuItem>
  <MenuItem value={"pending"}>Pending</MenuItem>
  <MenuItem value={"inactive"}>De-Activated</MenuItem>
  
</Select>
      </FormControl>



      <Paper
    onSubmit={(e)=>{e.preventDefault();getSupportLogs()}}
      component="form"
      sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
    >

      <InputBase
      
         sx={{ ml: 1, flex: 1 }}
        onChange={(e)=>setquery(e.target.value)}
        placeholder="Search Name, Email or Phone"
        inputProps={{ 'aria-label': 'Search Batch ID ' }}
      />
      <IconButton onClick={()=>getSupportLogs()} sx={{ p: '10px' }} aria-label="search">
        <SearchIcon />
      </IconButton>
      
    </Paper>

</div>


<h4>Top {internships?internships.length:0} Logs</h4>

 
</div>



<hr/>

</div>
<div className="internships-list  sm-p-0  container-fluid">

{ internships==="start"?
<div className="container-fluid">



    </div>

:internships?internships.map(internship=>(

<>
<div className={"flex container-fluid space-between align-items-center "}>

<div className="col-lg-4">
    <h6>{internship.page}</h6>
    <p className="extra-small">{internship.value}</p>
</div>

<div>
    {dateFormat(internship.date_time,"dS mmm hh:mm tt")}
</div>

<Dropdown className="options-dropdown">   
  <Dropdown.Toggle className="bg-white options p-0 w-fit h-fit  border-0" >
  <MoreVert className="text-dark"/>
  </Dropdown.Toggle>

  <Dropdown.Menu>
  <Dropdown.Item href="#">Schedules</Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>

</div>
</>
)):
<div className="container-fluid">

No Internships

    </div>

}





</div>




</div>

   



        </>
    )
}

export default WebsiteLogs